import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './SearchResult.css';

const PlaylistItem = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [pageToken, setPageToken] = useState('');
  const [showSavePopup, setShowSavePopup] = useState(false);
  const [playlistName, setPlaylistName] = useState('');
  const [playlistDescription, setPlaylistDescription] = useState('');
  const navigate = useNavigate();
  const { playlistId } = useParams();
  
  const API_LIST = [
    'AIzaSyAM9R1vr9t6GSrazqGtw5t8RBKmz2Q17dk',
    'AIzaSyCvaktMcshCgWbahXn7JuJcmhUlSR5ZxAA',
    'AIzaSyBboFo9umdEW03mwz8IdLsRVWXEeAyokdw',
    'AIzaSyAmw-1dYBqj1MIqccmtfeLWfgzYqROkylY',
    'AIzaSyA-xoSvUcnAYUK2v6sTeJtQT4NG9JxWrQg',
    'AIzaSyDwCaQVTwJsau514qhaWTMBlZ80iQgKLtM',
  ];

  const randomIndex = Math.floor(Math.random() * API_LIST.length);
  const API_KEY = API_LIST[randomIndex];
  const maxResults = 100;

  useEffect(() => {
    const loadPlaylistData = async () => {
      if (!playlistId) {
        console.log('null input');
        return;
      }

      setSearchResults([]);

      // First, check if playlist exists in localStorage
      const existingPlaylists = JSON.parse(localStorage.getItem('savedPlaylists') || '[]');
      const savedPlaylist = existingPlaylists.find(playlist => playlist.id === playlistId);

      if (savedPlaylist && savedPlaylist.items && savedPlaylist.items.length > 0) {
        // Load from localStorage
        console.log('Loading playlist from localStorage');
        setSearchResults(savedPlaylist.items);
        // Also save to sessionStorage for consistency
        sessionStorage.setItem(`playlist_${playlistId}`, JSON.stringify(savedPlaylist.items));
        return;
      }

      // If not in localStorage, check sessionStorage
      const sessionData = sessionStorage.getItem(`playlist_${playlistId}`);
      if (sessionData) {
        try {
          const parsedData = JSON.parse(sessionData);
          if (parsedData.length > 0) {
            console.log('Loading playlist from sessionStorage');
            setSearchResults(parsedData);
            return;
          }
        } catch (error) {
          console.error('Error parsing session data:', error);
        }
      }

      // If not found in either storage, fetch from API
      console.log('Fetching playlist from API');
      const fetchWithPagination = async (token = '') => {
        const API_URL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${playlistId}&key=${API_KEY}&maxResults=${maxResults}&pageToken=${token}`;

        try {
          const response = await fetch(API_URL);
          const data = await response.json();
          if (!response.ok || !data.items) {
            throw new Error("Invalid response or no data");
          }

          // Update state with the fetched items
          setSearchResults((prevResults) => {
            const newResults = [...prevResults, ...data.items];
            
            // Save to sessionStorage whenever we have data
            if (newResults.length > 0) {
              sessionStorage.setItem(`playlist_${playlistId}`, JSON.stringify(newResults));
            }
            
            return newResults;
          });

          // Update pageToken for the next page
          setPageToken(data.nextPageToken || '');

          // Fetch next page if there is a next page token
          console.log("playlist data: ", searchResults);

          if (data.nextPageToken) {
            await fetchWithPagination(data.nextPageToken);
          }
        } catch (error) {
          window.open(`https://www.youtube.com/playlist?list=${playlistId}`, "_blank");
          navigate(-1);
          console.error('Error fetching data:', error);
        }
      };

      // Start fetching with pagination
      await fetchWithPagination();
    };
    
    loadPlaylistData();
  }, [playlistId]);

  // Check if playlist is already saved and set initial state for save button
  const isPlaylistSaved = () => {
    const existingPlaylists = JSON.parse(localStorage.getItem('savedPlaylists') || '[]');
    return existingPlaylists.some(playlist => playlist.id === playlistId);
  };

  const handleSaveToLocalStorage = () => {
    if (!playlistName.trim()) {
      alert('Please enter a playlist name');
      return;
    }

    const playlistData = {
      id: playlistId,
      name: playlistName,
      description: playlistDescription,
      items: searchResults,
      savedAt: new Date().toISOString()
    };

    // Get existing saved playlists
    const existingPlaylists = JSON.parse(localStorage.getItem('savedPlaylists') || '[]');
    
    // Check if playlist already exists
    const existingIndex = existingPlaylists.findIndex(playlist => playlist.id === playlistId);
    
    if (existingIndex !== -1) {
      // Update existing playlist
      existingPlaylists[existingIndex] = playlistData;
    } else {
      // Add new playlist
      existingPlaylists.push(playlistData);
    }

    localStorage.setItem('savedPlaylists', JSON.stringify(existingPlaylists));
    
    setShowSavePopup(false);
    setPlaylistName('');
    setPlaylistDescription('');
    alert('Playlist saved successfully!');
  };

  const handleClosePopup = () => {
    setShowSavePopup(false);
    setPlaylistName('');
    setPlaylistDescription('');
  };

  if (!playlistId) {
    return <p>not available.</p>;
  }

  return (
    <div>
      <br />
      <br />
      <br />
      <h4 className="text-center text">Playlist</h4>
      
      {/* Save Button */}
      {searchResults.length > 0 && (
        <div className="text-center mb-3">
          <button 
            className={`btn ${isPlaylistSaved() ? 'btn-success' : 'btn-primary'}`}
            onClick={() => setShowSavePopup(true)}
          >
            {isPlaylistSaved() ? 'Update Playlist' : 'Save Playlist'}
          </button>
        </div>
      )}
      
      <hr/>
      
      <div className="container">
        <div className="row">
          {searchResults.map((item) => (
            <div key={`${item.id.videoId}-${Math.random()}`} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <Link to={`/Player/${playlistId}/${item.snippet.resourceId.videoId}`}>
                  <img
                    src={item.snippet.thumbnails.medium.url}
                    className="card-img-top"
                    alt={item.snippet.title}
                  />
                </Link>
                <div className="card-body">
                  <Link to={`/Player/${playlistId}/${item.snippet.resourceId.videoId}`} className="maincard1">
                    <h5 className="card-title">{item.snippet.title}</h5>
                  </Link>
                  <p className="font-weight-bold">{item.snippet.channelTitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Save Popup Modal */}
      {showSavePopup && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '400px',
            maxWidth: '90%'
          }}>
            <h5>Save Playlist</h5>
            <div className="form-group mb-3">
              <label htmlFor="playlistName">Playlist Name *</label>
              <input
                type="text"
                id="playlistName"
                className="form-control"
                value={playlistName}
                onChange={(e) => setPlaylistName(e.target.value)}
                placeholder="Enter playlist name"
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="playlistDescription">Description</label>
              <textarea
                id="playlistDescription"
                className="form-control"
                rows="3"
                value={playlistDescription}
                onChange={(e) => setPlaylistDescription(e.target.value)}
                placeholder="Enter playlist description (optional)"
              />
            </div>
            <div className="d-flex justify-content-end">
              <button 
                className="btn btn-secondary me-2"
                onClick={handleClosePopup}
              >
                Cancel
              </button>
              <button 
                className="btn btn-primary"
                onClick={handleSaveToLocalStorage}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      <br/>
      <br/>
    </div>
  );
};

export default PlaylistItem;